(() => {
    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1) {
        // isInfinite
        if (typeof Number.isFinite !== 'function') {
            Number.isFinite = function isFinite(value) {
                // 1. If Type(number) is not Number, return false.
                if (typeof value !== 'number') {
                    return false;
                }
                // 2. If number is NaN, +∞, or −∞, return false.
                if (value !== value || value === Infinity || value === -Infinity) {
                    return false;
                }
                // 3. Otherwise, return true.
                return true;
            };
        }
        // Object.values
        // @ts-ignore
        if (!Object.values) Object.values = o => Object.keys(o).map(k => o[k]);

        if (!String.prototype.startsWith) {
            String.prototype.startsWith = function(searchString, position){
              position = position || 0;
              return this.substr(position, searchString.length) === searchString;
          };
        }
    }

})()

export {};